import { CSSProperties, ReactNode } from 'react';
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';

type BlueprintCardWrapperProps = {
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        borderRadius: theme.spacing(2),
        overflow: 'hidden',
        boxShadow: '0px 0px 4px 0px #00000026',
        [theme.breakpoints.down('sm')]: {
          maxWidth: '430px',
        },
      },
    }),
  { name: 'blueprintCardWrapper' },
);

export const BlueprintCardWrapper = ({
  className,
  style,
  children,
}: BlueprintCardWrapperProps) => {
  const classes = useStyles();
  return (
    <Box className={clsx(classes.root, className)} style={style}>
      {children}
    </Box>
  );
};
